/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './UpdateBasicInfo.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UpdateBasicInfoMutationVariables = SchemaTypes.Exact<{
  uuid: SchemaTypes.Scalars['ID']['input'];
  dateOfBirth: SchemaTypes.Scalars['DateTime']['input'];
  gender: SchemaTypes.Scalars['String']['input'];
  zipCode: SchemaTypes.Scalars['String']['input'];
}>;


export type UpdateBasicInfoMutation = { __typename?: 'Mutation', customers: { __typename?: 'CustomersMutation', identity_profile_update: { __typename?: 'IdentityProfile', id: string, age: number, gender: string | null, dateOfBirth: string | null } | null, residence_profile_update: { __typename?: 'ResidenceProfile', id: string, zipCode: string | null, state: { __typename?: 'State', id: string, code: string, name: string } | null } | null, set_started_flow: { __typename?: 'Customer', id: string, userAttributes: string } | null } };


export function useUpdateBasicInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBasicInfoMutation, UpdateBasicInfoMutationVariables>(Operations.UpdateBasicInfo, options);
      }
export type UpdateBasicInfoMutationHookResult = ReturnType<typeof useUpdateBasicInfoMutation>;